// Business hours constants for the bakery
// Split schedule: Mon-Sat has morning and afternoon, Sunday is morning only

// Morning hours (all days)
export const MORNING_OPEN = "09:00";
export const MORNING_CLOSE = "14:00";

// Afternoon hours (Mon-Sat only)
export const AFTERNOON_OPEN = "16:30";
export const AFTERNOON_CLOSE = "20:30";

// Generate time slots for morning hours (30-minute intervals)
export const MORNING_TIME_SLOTS = [
  "09:00", "09:30", "10:00", "10:30", "11:00", "11:30", 
  "12:00", "12:30", "13:00", "13:30", "14:00"
];

// Generate time slots for afternoon hours (30-minute intervals, Mon-Sat only)
export const AFTERNOON_TIME_SLOTS = [
  "16:30", "17:00", "17:30", "18:00", "18:30", 
  "19:00", "19:30", "20:00", "20:30"
];

// Full day slots for Mon-Sat
export const WEEKDAY_TIME_SLOTS = [...MORNING_TIME_SLOTS, ...AFTERNOON_TIME_SLOTS];

// Sunday slots (morning only)
export const SUNDAY_TIME_SLOTS = MORNING_TIME_SLOTS;

// Legacy exports for backwards compatibility
export const OPENING_HOUR = MORNING_OPEN;
export const CLOSING_HOUR = AFTERNOON_CLOSE;
export const BUSINESS_TIME_SLOTS = WEEKDAY_TIME_SLOTS;

/**
 * Check if a given time is within business hours
 * @param time - Time in HH:mm format
 * @param dayOfWeek - Day of week (0 = Sunday, 1 = Monday, etc.)
 */
export const isWithinBusinessHours = (time: string, dayOfWeek?: number): boolean => {
  if (!time) return false;
  
  const isSunday = dayOfWeek === 0;
  
  // Morning hours: 09:00 - 14:00
  const isInMorning = time >= MORNING_OPEN && time <= MORNING_CLOSE;
  
  // Afternoon hours: 16:30 - 20:30 (not on Sundays)
  const isInAfternoon = !isSunday && time >= AFTERNOON_OPEN && time <= AFTERNOON_CLOSE;
  
  return isInMorning || isInAfternoon;
};

/**
 * Get available time slots for a specific date
 * @param date - The date to check (to determine if it's Sunday)
 */
export const getTimeSlotsForDate = (date: Date | string | null): string[] => {
  if (!date) return WEEKDAY_TIME_SLOTS;
  
  const dateObj = typeof date === "string" ? new Date(date) : date;
  const dayOfWeek = dateObj.getDay();
  
  // Sunday (0) - only morning hours
  if (dayOfWeek === 0) {
    return SUNDAY_TIME_SLOTS;
  }
  
  // Mon-Sat - full schedule
  return WEEKDAY_TIME_SLOTS;
};

/**
 * Validate a time for a specific date and return error message if invalid
 * @param time - Time in HH:mm format
 * @param date - The date (to check if it's Sunday)
 * @returns Error message or empty string if valid
 */
export const validateTimeForDate = (time: string, date: Date | string | null): string => {
  if (!time) return "";
  
  const dateObj = date ? (typeof date === "string" ? new Date(date) : date) : new Date();
  const dayOfWeek = dateObj.getDay();
  const isSunday = dayOfWeek === 0;
  
  if (!isWithinBusinessHours(time, dayOfWeek)) {
    if (isSunday) {
      return "La pastelería está cerrada a esa hora. Domingos: 09:00 - 14:00";
    }
    return "La pastelería está cerrada a esa hora. Horario: 09:00-14:00 y 16:30-20:30";
  }
  
  return "";
};

// Legacy error message (for backwards compatibility)
export const INVALID_TIME_MESSAGE = "La pastelería está cerrada a esa hora. Horario: 09:00-14:00 y 16:30-20:30";
